import { render, staticRenderFns } from "./PartyOnboardingReview.vue?vue&type=template&id=64b548c8"
import script from "./PartyOnboardingReview.vue?vue&type=script&lang=js"
export * from "./PartyOnboardingReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports